export const AssignMobileAPI = async (phone, businessName, assigner) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}send-assign-mobile`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                phone: phone,
                businessName: businessName,
                assigner: assigner,
                type: "whatsapp"
            })
        });

        if (!response.ok) {
            console.error(`Failed to send assign mobile, status: ${response.status}`);
            return null;
        }

        return await response.json();

    } catch (error) {
        console.error("Error sending assign mobile:", error);
        return null;
    }
};
